import { Trans } from '@lingui/react/macro';
import { cn } from 'noddi-ui-common';
import { NoddiButton } from 'noddi-ui-web';
import { useState } from 'react';
import { RejectModal } from './RejectModal';

type Props = {
  id: number;
  onRejected?: () => void;
  /** Override the stacked full-width default when the link sits in a row of actions. */
  className?: string;
};

export const RejectButtonAndModal = ({ id, onRejected, className = 'w-full' }: Props) => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <RejectModal id={id} open={isOpen} onClose={() => setIsOpen(false)} onRejected={onRejected} />
      <NoddiButton
        onClick={(event) => {
          event.preventDefault();
          event.stopPropagation();
          setIsOpen(true);
        }}
        size='small'
        className={cn('text-muted-foreground', className)}
        variant='link'
      >
        <Trans>Not interested?</Trans>
      </NoddiButton>
    </>
  );
};
